import { DateTime } from 'luxon';
import { DateObject } from 'react-multi-date-picker';

export const dateTimeToDateObject = (input: DateTime): DateObject =>
  new DateObject(input.toJSDate());

export const dateObjectToDateTime = (input: DateObject): DateTime =>
  DateTime.fromJSDate(input.toDate());
